export default {"src":"/_next/static/image/public/clone.d7a90f09a2bce352c3f2ddf9d1a5ae95.svg","height":512,"width":512};